import { Pipe, PipeTransform } from '@angular/core';

import { clienteCadastros } from '../cliente-cadastro';

@Pipe({
    name: 'clienteCadastroBadge'
})
export class ClienteCadastroBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteCadastros.findIndex(cadastro => cadastro.id === value);
        if (index > -1) {
            return clienteCadastros[index].badge;
        }
        return '';
    }
}
